import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M10 7a2 2 0 1 1 4 0v3h3a2 2 0 1 1 0 4h-3v3a2 2 0 1 1-4 0v-3H7a2 2 0 1 1 0-4h3z",
      clipRule: "evenodd"
    }
  )
);
var SvgAnalyticsPlusOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AnalyticsPlusOutlined_default = SvgAnalyticsPlusOutlined;

export { AnalyticsPlusOutlined_default as default };
